import { observer } from 'mobx-react-lite';
import { DrawerHeader, HStack, IconButton, Text } from '@cad-arc';
import { useNavigate } from 'react-router-dom';
import { QueueDisplayDensityEnum } from '@mark43/cad-api';
import { QueueSearchInput } from '../../queues/components/queue-search-input';
import { FR_UNITS_LIST_PATH } from '../../router/constants';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';
import { FrUnitsTypeFilterMenu } from '../fr-units-type-filter-menu';
import { FrUnitsSortMenu } from '../fr-units-sort-menu';
import { useQueueStore } from '../../queues/context/use-queue-store';

export const FrUnitsListHeader = observer(function FrUnitesListHeader() {
    const navigate = useNavigate();
    const { close } = useDrawerControls();
    const queueStore = useQueueStore();

    const onClick = () => {
        queueStore.setDisplayDensity(QueueDisplayDensityEnum.COMPACT.name);
        close();
        navigate(FR_UNITS_LIST_PATH);
    };

    return (
        <DrawerHeader>
            <HStack justifyContent="space-between" flex="1">
                <Text variant="headingLg" fontWeight="bold">
                    Units
                </Text>
                <HStack justifyContent="flex-end" pr={8}>
                    <QueueSearchInput searchButtonVariant="outline" />
                    <FrUnitsTypeFilterMenu />
                    <FrUnitsSortMenu />
                    <IconButton
                        data-testid="UNITS_LIST_EXPAND_DRAWER"
                        aria-label="expand units drawer"
                        icon="ExpandWindow"
                        onClick={onClick}
                        variant="outline"
                    />
                </HStack>
            </HStack>
        </DrawerHeader>
    );
});
